module.exports = __webpack_public_path__ + "media/control_acceso/corredizo_labeled-11721c8d.png";